/** Shared words and states (docs/specs/admin-shell.md). English is the source language. */
export const common = {
    appName: "Sobthik",
    actions: {
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        close: "Close",
        retry: "Try again",
        loadMore: "Load more",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        signOut: "Sign out",
        view: "View",
    },
    states: {
        loading: "Loading…",
        empty: "Nothing here yet",
        error: "Something went wrong",
        errorReference: "Reference: {{requestId}}",
        offline: "Can't reach the server. Check your connection and try again.",
    },
    /** SB-05: the "Try it yourself" demo business (docs/specs/sandbox.md). */
    sandbox: {
        badge: "Demo shop",
        endsIn: "This demo ends in {{time}}",
        hoursMinutes: "{{hours}} h {{minutes}} min",
        minutes: "{{minutes}} min",
        ended: "This demo has ended",
        signup: "Open a real account — free trial",
        checklistTitle: "Try these five things",
        checklistBody: "Everything here is real: the same system a shop runs on every day.",
        progress: "{{done}} of {{total}} done",
        hide: "Hide checklist",
        show: "Show checklist",
        done: "Done",
        steps: {
            pos_sale: { title: "Make a sale on the POS", action: "Open the POS" },
            offline_sale: { title: "Turn the POS's internet off and sell again", action: "Open the POS" },
            online_order: { title: "Order something from your own website", action: "Open your shop" },
            courier_booked: { title: "Book a courier for an order", action: "Go to orders" },
            report_viewed: { title: "Open a report and see the profit", action: "Go to reports" },
        },
        enter: {
            title: "Opening your demo shop…",
            failed: "This demo link has expired or was already used.",
            again: "Start a new demo",
        },
    },
    theme: { label: "Theme", light: "Light", dark: "Dark", system: "System" },
    language: { label: "Language", en: "English", bn: "বাংলা" },
    numerals: { label: "Digits", latin: "English digits (123)", bengali: "Bengali digits (১২৩)" },
    tenant: { label: "Business", switch: "Switch business" },
    notFound: {
        title: "Page not found",
        body: "The page you are looking for does not exist or has moved.",
        home: "Go to dashboard",
    },
    noAccess: {
        title: "No access",
        body: "You don't have permission to view this. Ask an owner or manager.",
    },
    filters: { title: "Filters", clear: "Clear filters" },
    /** Plan limits and features (docs/specs/platform.md Part 2). */
    plan: {
        limitReached: "Your plan's limit for {{thing}} is {{limit}}. Upgrade the plan, or archive or deactivate one to make room.",
        featureOff: "Your plan doesn't include this. Upgrade the plan to use it.",
        featureOffOn: "Your plan doesn't include this. It comes with {{plan}} — upgrade to use it.",
        things: {
            locations: "locations",
            users: "staff users",
            devices: "POS devices",
            products: "products",
            orders: "orders a month",
            landingPages: "landing pages",
        },
    },
    form: { unsaved: "You have unsaved changes.", saved: "All changes saved.", details: "Details" },
    timeline: "Timeline",
    table: {
        columns: "Columns",
        noResults: "No results",
        selectAll: "Select all rows",
        selectRow: "Select row",
        selected_one: "{{count}} selected",
        selected_other: "{{count}} selected",
    },
    editor: {
        toolbar: "Formatting",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        strike: "Strikethrough",
        heading2: "Heading",
        heading3: "Subheading",
        bulletList: "Bulleted list",
        orderedList: "Numbered list",
        quote: "Quote",
        link: "Link",
        linkPrompt: "Link address (https://…). Leave empty to remove the link.",
        rule: "Divider line",
        undo: "Undo",
        redo: "Redo",
    },
};
//# sourceMappingURL=common.js.map